import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const userBaseEndpoint = ENDPOINTS.USER;

// Daily Orders API
export const employeeApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["employees"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      // getEmployees: builder.query({
      //   query: (payload) => `${userBaseEndpoint}employee?per_page=${payload}`,
      //   transformResponse: (response) => response,
      //   providesTags: () => [{ type: "employees" }],
      //   // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      // }),
      getEmployees: builder.query({
        query: ({ page = 1, per_page = 10, search = "" } = {}) => ({
          url: `${userBaseEndpoint}employee`,
          params: {
            page,
            per_page,
            ...(search && { search }),
          },
        }),
        transformResponse: (response) => response,
        providesTags: () => [{ type: "employees" }],
      }),

      addEmployee: builder.mutation({
        query: (requestData) => ({
          url: `${userBaseEndpoint}add-staff`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "employees" }],
      }),

      updateEmployee: builder.mutation({
        query: ({ id, ...requestData }) => ({
          url: `${userBaseEndpoint}update-staff/${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "employees" }],
      }),
      deleteEmployee: builder.mutation({
        query: (id) => ({
          url: `${userBaseEndpoint}delete-staff/${id}`,
          method: METHODS.DELETE,
        }),
        invalidatesTags: () => [{ type: "employees" }],
      }),
    }),
  });

// Export hooks for usage in components

export const {
  useGetEmployeesQuery,
  useAddEmployeeMutation,
  useUpdateEmployeeMutation,
  useDeleteEmployeeMutation,
} = employeeApi;
